import { useEffect } from "react";
import { setPaymentDetails } from "../../../actions/payment"
import { PaymentSetup } from "./PaymentsSetup"
import { useDispatch, useSelector } from "react-redux";
import { useSideTabs } from "../../../hooks/useSideTabs";
import { ISidebarItem } from "../../Routes";
import { IReduxAppState } from "../../../reducers";
import { AdvertCard } from "./OpenBanking/AdvertCard";
import { useSubscription } from "../../../hooks/useSubscription";
import { Source } from "../../subscription/types.d";
import { DirectMerchantSubscriptions } from "../../subscription/DirectMerchant";
import Styles from "../../../scss/subscriptions.module.scss";
import { IntegrationsList } from "../../orders/constants";
import { OnboardingSources } from "../../signup/types";
import { useFlags } from "launchdarkly-react-client-sdk";
import { PERMISSIONS } from "../../../const/permissions.const";
import useCheckPermissions from "../../../hooks/useCheckPermissions";
export interface IPaymentsPage {
  venueId: string;
  venueName: string;
  acquirerName?: string;
  paymentProcessor?: string | null;
  onboardingSource?: string;
  tab: ISidebarItem;
}

export default function PaymentContainer(props: IPaymentsPage) {
  const dispatch = useDispatch();
  useSideTabs(props.tab);
  const { OnboardingSource } = useSubscription();
  const venueId = useSelector((state: IReduxAppState) => state.selectedVenueId)
  const paymentStage = useSelector((state: IReduxAppState) => state.payments.paymentStage);
  const isEposNow = useSelector((state: IReduxAppState) => state.isEposNow);
  const venueData = useSelector((state: IReduxAppState) => state.venue[venueId].venueData);
  const isPay360 = venueData?.payment_processor === "PAY360";
  const { hasObAccess } = useFlags();
  const isIntegration = IntegrationsList.includes(OnboardingSource as OnboardingSources);


  const { hasPermission } = useCheckPermissions(PERMISSIONS.BILLING_AND_PAYMENT);

  useEffect(() => {
    dispatch(setPaymentDetails({
      venueName: props.venueName,
      paymentProcessor: props.paymentProcessor ? props.paymentProcessor : "STRIPE",
      acquirerName: props.acquirerName,
      onboardingSource: props.onboardingSource ? props.onboardingSource : "YOELLO"
    }))
    // eslint-disable-next-line
  }, [props.paymentProcessor, props.venueName, props.acquirerName, props.onboardingSource])

  if(!hasPermission) {
    return null;
  }
  
  return <>
    {OnboardingSource === Source.Yoello &&
      <div className={`${Styles.SubscriptionsContainer} ${Styles.FullSubscriptions}`}>
        <DirectMerchantSubscriptions />
      </div>
    }
    <PaymentSetup />
    {!isIntegration && !isEposNow && !isPay360 && paymentStage === 4 && hasObAccess && <AdvertCard />}
  </>;
}
